import { Page } from '@/core/architecture'

import { AccountSettingsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * AccountSettings Page
 * Implemented as a practical sample.
 */
export const AccountSettings: Page = () => {
  const { state, actions } = useViewModel()

  return <AccountSettingsTemplate state={state} />
}
